import { useBreakpointValue } from '@cmpsr/components';

export default function useIsMobile() {
  return useBreakpointValue({ base: true, lg: false }, { ssr: false }) ?? true;
}
